import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "max-w-full" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = {
  class: "flex px-1 bg-gray-800 rounded-t-lg",
  "aria-label": "Tabs"
}
const _hoisted_4 = ["onClick", "aria-current"]
const _hoisted_5 = { class: "w-full bg-black rounded-xs p-2 overflow-auto" }
const _hoisted_6 = { class: "whitespace-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("nav", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.INSTALLERS, (installer) => {
          return (_openBlock(), _createElementBlock("span", {
            key: installer,
            onClick: ($event: any) => (_ctx.selectInstaller(installer)),
            class: _normalizeClass([
						installer == _ctx.currentInstaller
							? 'border-emerald-700 text-emerald-700'
							: 'border-transparent text-gray-400 hover:text-emerald-500 hover:border-emerald-500',
						'whitespace-nowrap py-1 px-2 border-b-2 font-medium text-sm cursor-pointer',
					]),
            "aria-current": installer == _ctx.currentInstaller ? 'page' : undefined
          }, _toDisplayString(installer), 11 /* TEXT, CLASS, PROPS */, _hoisted_4))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("pre", _hoisted_5, [
      _createElementVNode("code", _hoisted_6, _toDisplayString(_ctx.displayedCode), 1 /* TEXT */)
    ])
  ]))
}